"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmergencySection = void 0;
const ui_1 = require("@app/component/ui");
const form_grid_layout_1 = require("@app/component/ui/forms/form-grid-layout");
const util_1 = require("@app/util");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const emergency_item_1 = require("../components/emergency-item");
const shift_modal_section_1 = require("../components/shift-modal-section");
const shift_context_1 = require("../shift-context");
const detect_start_duration_overlap_1 = require("../util/detect-start-duration-overlap");
const _getLastActivityEnd = (standByActivities) => {
    let latest = 0;
    standByActivities.forEach((activity) => {
        const _activity = (0, maybe_unwrap_1.unwrapMaybe)(activity);
        if ((0, util_1.isUndefined)(_activity))
            return;
        if (!(0, util_1.isValue)(_activity.start))
            return;
        if (!(0, util_1.isValue)(_activity.duration))
            return;
        if (_activity.start + _activity.duration > latest) {
            latest = _activity.start + _activity.duration;
        }
    });
    return latest;
};
const getDefaultStandByActivity = (activities) => ({
    note: undefined,
    duration: 60,
    start: activities?.length ? _getLastActivityEnd(activities) : 0,
});
const EmergencySection = () => {
    const { formControl, disabledEditation } = (0, shift_context_1.useShift)();
    const { fields, remove, update, append } = (0, react_hook_form_1.useFieldArray)({
        control: formControl,
        name: 'standByActivities',
        keyName: 'standByFieldId',
        rules: {
            validate: (activities) => {
                const resultOverlaps = (0, detect_start_duration_overlap_1.detectOverlaps)(activities);
                if (resultOverlaps.length > 0) {
                    return (0, util_1.t)('ERR_MESSAGE.shift.activityOverlap') ?? true;
                }
            },
        },
    });
    const resultOverlaps = (0, detect_start_duration_overlap_1.detectOverlaps)(fields);
    return (react_1.default.createElement(shift_modal_section_1.ShiftModalSection, { id: 'emergency', headerContent: react_1.default.createElement(ui_1.Button, { style: 'BORDERLESS', ico: 'plus', onClick: () => append(getDefaultStandByActivity(fields)), disabled: (0, util_1.isDefined)(disabledEditation) }, (0, util_1.t)('SHIFT_STANDBY_ADD_ACTIVITY')) },
        react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: '0.5rem' } }, fields.map((field, index) => (react_1.default.createElement(react_1.default.Fragment, { key: field.standByFieldId },
            react_1.default.createElement("div", { style: {
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'end',
                    position: 'relative',
                } },
                react_1.default.createElement("div", { style: { position: 'absolute', bottom: '-1.5rem' } },
                    react_1.default.createElement(ui_1.Button, { color: 'RED', style: 'BORDERLESS', ico: 'delete', onClick: () => remove(index), disabled: (0, util_1.isDefined)(disabledEditation) }, (0, util_1.t)('DELETE')))),
            react_1.default.createElement(form_grid_layout_1.FormGridLayout, null,
                react_1.default.createElement(emergency_item_1.EmergencyItem, { index: index, field: field, error: {
                        hasError: resultOverlaps.some((overlap) => overlap.secondOverlapIndex === index),
                        errorMessage: resultOverlaps.some((overlap) => overlap.secondOverlapIndex === index)
                            ? (0, maybe_unwrap_1.unwrapMaybe)((0, util_1.t)('ERR_MESSAGE.shift.activityOverlap'))
                            : undefined,
                    }, update: update })),
            index !== fields.length - 1 && react_1.default.createElement(ui_1.Separator, null)))))));
};
exports.EmergencySection = EmergencySection;
